/**
 * Module « À relancer » — bible §7, priorité 1.
 * V1 de la tranche : file RELATION opérationnelle ; les files Travaux et
 * Finance affichent leur prérequis (pas de faux boutons, §0.1).
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "relances",
  label: "À relancer",
  icon: "i-bell",
  navGroup: "pilotage",
  navOrder: 20,
  rolesRequis: [],
  routes: [{ path: "/relances", component: lazy(() => import("./routes/FileRelation")) }],
};

export default mod;
